import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Fieldset} from "primereact/fieldset";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

const _FM_ServicepackageFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [itemFormData, setItemFormData] = useState({});
  const [services, setServices] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({})
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderServicepackageList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderServicepackageList: true,
            //selectedCategoryId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (id) {
      setLoading(true)
      setItemFormData({
        ...itemFormData,
        service_package: id
      })
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setServices(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/service-package-item-unit",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setUnits(response.data.data);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col"}>
                  <h2 className={"p-m-0"}>{t('servicepackage_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-12"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className="p-col-12 p-lg-6">
                  <Field name="type" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="type"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>
                        {t('type')}
                      </label>
                      <span className="p-d-block">
                            <Dropdown  options={[
                              // {
                              //   name: t('percent'),
                              //   value: 'PERCENT',
                              // },
                              {
                                name: t('amount'),
                                value: 'AMOUNT',
                              },
                            ]}
                                      filter
                                      optionLabel="name"
                                      optionValue="value"
                                      id={"type"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          type: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          type: e.value
                                        })
                                      }}
                                      value={formData.type}
                            />
                          </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="value" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"value"}/>
                      <label htmlFor="value"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('value')}</label>
                      <span className="p-d-block">
                      <InputText id="value" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     value: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     value: e.target.value
                                   })
                                 }}
                                 value={formData.value}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>

              </div>
            </Panel>
          </form>
        )}/>
        <Panel className={"p-mt-3"}>
          <h3 className={"p-mt-0"}>
            {t('servicepackage_items_and_prices')}
          </h3>
          <table className={"w-100 p-datatable-table table-striped item-add-table"} cellPadding={0} cellSpacing={0}
                 border={0}>
            <tr>
              <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('service')}</th>
              <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('price')}</th>
              <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('unit')}</th>
              <th></th>
            </tr>
            {formData.service_package_items && formData.service_package_items[0] &&
              <>
                {formData.service_package_items.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {item?.service?.name}
                      </td>
                      <td className={"p-text-right"}>
                        {currencyFormatter.format(
                          item.value, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )}
                      </td>
                      <td className={"p-text-right"}>
                        {item.unit}
                      </td>
                      <td className={"p-text-right"}>
                        <Button icon="pi pi-trash" className="p-button-sm p-button-danger p-p-1"
                                tooltip={t('delete')}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  window.App.setState({[`confirmDeleteRackpriceItem${item.id}`]: true})
                                }}
                        />
                        <ConfirmDialog group="declarative"
                                       visible={window.App.state[`confirmDeleteRackpriceItem${item.id}`]}
                                       acceptLabel={t('yes')} rejectLabel={t('no')}
                                       onHide={() => {
                                         window.App.setState({[`confirmDeleteRackpriceItem${item.id}`]: false})
                                       }}
                                       message={t('confirm_delete')} header={t('confirm_delete')}
                                       icon="pi pi-exclamation-triangle"
                                       accept={() => {
                                         setLoading(true)
                                         window.App.delete('service-package-item', item.id)
                                           .then(response => {
                                             window.App.toastShow('success', t('success_delete'),);
                                             axios({
                                               method: 'get',
                                               url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package/" + id,
                                               params: {},
                                               headers: {
                                                 'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                 "Sys-name": Cookies.get("instanceId"),
                                                 "Preferred-locale": Cookies.get("language")
                                               }
                                             })
                                               .then(response => {
                                                 setLoading(false)
                                                 setFormData(response.data.data);
                                                 if (response.data && response.data.data && response.data.data.under_edit_from
                                                   && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                                                   setLocking(true)
                                                 }
                                               })
                                               .catch(error => {
                                                 window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                 setLoading(false)
                                               })
                                           })
                                           .catch(error => {
                                             window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                           })
                                       }}
                                       reject={() => {
                                         window.App.setState({[`confirmDeleteRackpriceItem${item.id}`]: false})
                                       }}/>
                      </td>
                    </tr>
                  )
                })}
              </>
            }
          </table>
          <Fieldset
            className={"item-add p-mt-3"}
            legend={<span className={"item-add-legend"}><i className={"pi pi-plus"}></i><span>Új elem hozzáadása</span></span>}
          >
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
                <div className="p-field p-fluid">
                  <label htmlFor="service">{t('service')}</label>
                  <Dropdown  options={services}
                            filter
                            placeholder={t('service')}
                            optionLabel="name"
                            optionValue="id"
                            id={"service"}
                            emptyMessage={t('empty_message')}
                            onChange={(e) => {
                              setItemFormData({
                                ...itemFormData,
                                service: e.target.value
                              })
                            }}
                            value={itemFormData.service}
                            className={"p-p-0"}
                            showClear
                  />
                </div>
              </div>
              <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
                <div className="p-field p-fluid">
                  <label htmlFor="value">{t('price')}</label>
                  <InputText id="value"
                             className={"p-inputtext-sm"}
                             onChange={(e) => {
                               setItemFormData({
                                 ...itemFormData,
                                 value: e.target.value
                               })
                             }}
                             placeholder={t('price')}
                             value={itemFormData.value}
                  />
                </div>
              </div>
              <div className={"p-col-12 p-lg-4 grid-col-label-input"}>
                <div className="p-field p-fluid">
                  <label htmlFor="unit">{t('unit')}</label>
                  <Dropdown  options={units}
                            filter
                            placeholder={t('unit')}
                            optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                            optionValue="value"
                            id={"unit"}
                            emptyMessage={t('empty_message')}
                            onChange={(e) => {
                              setItemFormData({
                                ...itemFormData,
                                unit: e.target.value
                              })
                            }}
                            value={itemFormData.unit}
                            className={"p-p-0"}
                            showClear
                  />
                </div>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-text-right"}>
                <Button icon="pi pi-plus" className="p-button-sm p-button-success p-p-1"
                        label={t('save_new_item_label')}
                        tooltip={t('add')}
                        tooltipOptions={{position: 'left'}}
                        disabled={!itemFormData.service || !itemFormData.value}
                        onClick={() => {
                          setLoading(true)
                          axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package-item",
                            itemFormData, {
                              params: {},
                              headers: {
                                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                "Sys-name": Cookies.get("instanceId"),
                                "Preferred-locale": Cookies.get("language")
                              }
                            })
                            .then(response => {
                              setItemFormData({
                                ...itemFormData,
                                unit: null,
                                value: 0,
                                service: null,
                              })
                              axios({
                                method: 'get',
                                url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-package/" + id,
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                                .then(response => {
                                  setLoading(false)
                                  setFormData(response.data.data);
                                  if (response.data && response.data.data && response.data.data.under_edit_from
                                    && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                                    setLocking(true)
                                  }
                                })
                                .catch(error => {
                                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                  setLoading(false)
                                })
                              window.App.toastShow('success', t('success'), response.data.message)
                            })
                            .catch(error => {
                              setLoading(false)
                              window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                            })
                        }}
                />
              </div>
            </div>
          </Fieldset>
        </Panel>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ServicepackageFormComponent);
